import Vue from 'vue'
import VueRouter from 'vue-router'

import { view } from './view'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'hash',
  base: __dirname,
  linkActiveClass: 'active',
  routes: [{
    path: '/',
    redirect: '/main'
  }, {
    path: '/main',
    component: view('travel/Main')
  }, {
    path: '/tour',
    component: view('travel/Tour')
  }, {
    path: '/404',
    component: view('pages/404')
  }, {
    path: '/500',
    component: view('pages/500')
  }, {
    path: '*',
    redirect: '/404'
  }, {
    path: '/error',
    component: view('pages/error')
  }]
})

export default router



// WEBPACK FOOTER //
// ./src/configs/router/index.js